/*
 * 配列関連のバリデーション
 */
/**
 * 配列内に要素があるか
 * @param text エラー文言
 */
export const hasArrayItem = (text) => (values) => Array.isArray(values) && values.length > 0 ? undefined : text;
